import { withForm } from '@casanova/casanova-common';

export default withForm;
